import React, { createContext, useContext, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const [snackbars, setSnackbars] = useState([]);

  const handleClose = (id) => {
    setSnackbars((prevSnackbars) => prevSnackbars.filter((snackbar) => snackbar.id !== id));
  };

  const positionMap = {
    'top-left': { vertical: 'top', horizontal: 'left' },
    'top-right': { vertical: 'top', horizontal: 'right' },
    'bottom-left': { vertical: 'bottom', horizontal: 'left' },
    'bottom-right': { vertical: 'bottom', horizontal: 'right' },
  };

  const addSnackbar = (newMessage, options = {}) => {
    const {
      severity = 'success',
      position = 'top-right',
      transitionDirection = 'left',
      variant = 'filled',
      duration = 2000,
      autoClose = true,
      CSS = {},
      icon = true,
      effect = Slide, // Default to Slide effect if not specified
      close = false, // disabled the close button
      ...otherOptions // Capture any other options passed
    } = options;

    const anchorOrigin = positionMap[position] || { vertical: 'top', horizontal: 'right' };
    const id = Date.now();
    const newSnackbar = {
      id,
      message: newMessage,
      severity,
      position,
      transitionDirection,
      variant,
      duration,
      autoClose,
      CSS,
      anchorOrigin,
      icon,
      effect,
      close,
    };
    setSnackbars((prevSnackbars) => [...prevSnackbars, newSnackbar]);

    if (autoClose) {
      setTimeout(() => handleClose(id), duration);
    }
  };

  return (
    <SnackbarContext.Provider value={{ addSnackbar }}>
      {children}
      <div id="snackbar-container">
        {snackbars.map((snackbar) => (
          <Snackbar
            key={snackbar.id}
            open={true}
            autoHideDuration={snackbar.duration}
            onClose={snackbar.close ? () => handleClose(snackbar.id) : null}
            anchorOrigin={snackbar.anchorOrigin}
            TransitionComponent={snackbar.effect}
            TransitionProps={{ direction: snackbar.transitionDirection }}
          >
            <Alert
              onClose={snackbar.close ? () => handleClose(snackbar.id) : null}
              severity={snackbar.severity}
              variant={snackbar.variant}
              sx={snackbar.CSS}
              icon={snackbar.icon}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        ))}
      </div>
    </SnackbarContext.Provider>
  );
};